
export const userColumns = [
 
    {
      field: "icdCode",
      headerName: "Icd Code",
      width: 200,
    },
    {
      field: "diagnosisCode",
      headerName: "Diagnosis Code",
      width: 200,
    },
    {
      field: "diagnosisName",
      headerName: "Diagnosis Name",
      width: 200,
    },
  
  ];
  